import { useFormStore } from '@/stores/form'
import lookups from '@/assets/json/clientLookups.json'

async function checkViolatedFiles(source) {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const { serviceTransactionId } = globalStore.startedService
  const {
    requestCancelTransaction: { residencyCancel, exceptionalResidencyCancel },
    transactionReason: { residencyDeadInsideCountry }
  } = lookups
  const { transactionReasonId, resiDepartmentCode, resiYear, resiServiceCode, resiSequenceNumber } =
    formStore.draft.request
  if (!resiDepartmentCode || !resiYear || !resiServiceCode || !resiSequenceNumber) {
    return
  }
  let cancelResidency =
    [residencyCancel, exceptionalResidencyCancel].includes(serviceTransactionId) &&
    transactionReasonId == residencyDeadInsideCountry
  let is331AndExcResiCancel =
    [exceptionalResidencyCancel].includes(serviceTransactionId) && transactionReasonId == 331
  if (cancelResidency || is331AndExcResiCancel) {
    return
  }
  getPersonByUnifiedNumberOrFileNumber()
}

async function getPersonByUnifiedNumberOrFileNumber() {
  const formStore = useFormStore()
  const {
    personUnifiedNumber = '',
    resiDepartmentCode,
    resiSequenceNumber,
    resiServiceCode,
    resiYear
  } = formStore.form.values
  const params = {
    departmentCode: resiDepartmentCode,
    moduleId: 1,
    resiSequenceNumber,
    resiServiceCode,
    resiYear,
    unifiedNumber: personUnifiedNumber
  }
  const res = await apiHelperService.get('/api/user/usersInfoByUnifiedNumberOrFileNumber', {
    params
  })
  if (res) {
    const { numberOfRecords, collection = [] } = res
    if (numberOfRecords >= 1 && collection.length >= 1) {
      formStore.extraMap.fileServiceId = collection[0].fileServiceId || ''
    }
  }
}
export default function (actionName, actionParams) {
  switch (actionName) {
    case 'checkViolatedFiles':
      return checkViolatedFiles(actionParams)
    default:
      break
  }
}
